export const ROLE = {
    USER: "USER",
    IMPERSONATION: "IMPERSONATION",
    IMPERSONATION_PROJECTS: "IMPERSONATION_PROJECTS",
    REPORTS: "REPORTS",
    LOCKING: "LOCKING",
    ADMINISTRATOR: "ADMINISTRATOR",
    USER_MANAGEMENT: "USER_MANAGEMENT",
};

export const ROLE_DICTIONARY = {
    [ROLE.USER]: "User",
    [ROLE.IMPERSONATION]: "Impersonation",
    [ROLE.IMPERSONATION_PROJECTS]: "ImpersonationProjects",
    [ROLE.REPORTS]: "Reports",
    [ROLE.LOCKING]: "Locking",
    [ROLE.ADMINISTRATOR]: "Administrator",
    [ROLE.USER_MANAGEMENT]: "UserManagement",
};
